import Repository from '@/repositories/repository'

const PreRegRepository = {
  async getPreReg(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('pre-registration', 'page', params)
  }
}

export default PreRegRepository
